import cn from "classnames";
import { DialogHeader } from "./dialog-header";
import { DialogFullscreenProps } from "./types";
import styles from "./styles.module.scss";

export const DialogFullscreen = ({
  title,
  footer,
  children,
  className,
  showCloseIcon,
  dataTestId,
  onBack,
  onClose,
}: DialogFullscreenProps) => {
  const bodyDataTestId = `${dataTestId}-body`;
  const footerDataTestId = `${dataTestId}-footer`;

  return (
    <div className={cn(className, styles.dialog)}>
      <DialogHeader
        title={title}
        showCloseIcon={showCloseIcon}
        dataTestId={dataTestId}
        onBack={onBack}
        onClose={onClose}
      />

      <div className={styles.body} data-test-id={bodyDataTestId}>
        <div
          className={styles["body-inner"]}
          data-test-id={`${bodyDataTestId}-inner`}
        >
          {children}
        </div>
      </div>

      {footer && (
        <div className={styles.footer} data-test-id={footerDataTestId}>
          <div
            className={styles["footer-inner"]}
            data-test-id={`${footerDataTestId}-inner`}
          >
            {footer}
          </div>
        </div>
      )}
    </div>
  );
};
